import { actionConstants } from './actionConstants';
import noti from './toast';
import { get, post, put, _delete } from './method';

export default {
  resetPassword,
  expirePassword,
  lockUser,
  unlockUser,
  activeUser,
  inactiveUser,
  getUserDetail,
  getDeptSettings,
};

function resetPassword(userId, params) {
  return async (dispatch) => {
    let _params = {
      body: params,
    };
    return await post(`app/users/${userId}/password/reset`, _params)
      .then((resp) => {
        noti.success('Reset password successful');
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        throw error.response.data.error.message;
      });
  };
}

function expirePassword(userId) {
  return async (dispatch) => {
    return await put(`app/users/${userId}/password/expire`)
      .then(() => {
        noti.success('Expire password successful');
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        throw error.response.data.error.message;
      });
  };
}

function lockUser(userId) {
  return async (dispatch) => {
    return await put(`app/users/${userId}/lock`)
      .then(() => {
        noti.success('Lock user successful');
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        throw error.response.data.error.message;
      });
  };
}

function unlockUser(userId) {
  return async (dispatch) => {
    return await put(`app/users/${userId}/unlock`)
      .then(() => {
        noti.success('Unlock user successful');
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        throw error.response.data.error.message;
      });
  };
}

function activeUser(userId) {
  return async (dispatch) => {
    return await put(`app/users/${userId}/active`)
      .then(() => {
        noti.success('Mark user active successful');
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        throw error.response.data.error.message;
      });
  };
}

function inactiveUser(userId) {
  return async (dispatch) => {
    return await put(`app/users/${userId}/inactive`)
      .then(() => {
        noti.success('Mark user inactive successful');
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        throw error.response.data.error.message;
      });
  };
}

async function getUserDetail(userId) {
  return await get(`app/users/${userId}`)
    .then((resp) => {
      return resp;
    })
    .catch((error) => {
      noti.error(error.response.data.error.message);
      throw error.response.data.error.message;
    });
}

async function getDeptSettings(deptId) {
  return await get(`app/departments/${deptId}/settings/by-locale/en_US`);
}
